<div class="scroll-box">
  <div class="tone-grid">
    <div>
      <h4>Let's define audience and tone of your post</h4>
    </div>
  </div>

  <div>
    <p class="subheader">Post audience</p>
  </div>
  <form [formGroup]="workflowForm">
    <textarea
      formControlName="postAudience"
      placeholder="E.g. C-level executives, consultants"
      maxlength="{{ postToneMax }}"
    ></textarea>
    <span class="counter">{{ postToneCount }}/{{ postToneMax }}</span>
  </form>

  <p class="suggestion-subheader">
    Suggested post audience based on your description:
  </p>
  <form [formGroup]="workflowForm">
    <div
      *ngIf="workflowForm.get('postAudienceSuggestions').value?.length"
      class="suggestions-buttons"
    >
      <ng-container
        *ngFor="
          let suggestion of workflowForm.get('postAudienceSuggestions').value
            | stringToList
        "
      >
        <button
          class="suggestions-button"
          (click)="selectSuggestion(suggestion)"
        >
          {{ suggestion }}
        </button>
      </ng-container>
    </div>
    <div
      *ngIf="!workflowForm.get('postAudienceSuggestions').value?.length"
      class="no-suggestions"
    >
      No suggestions available.
    </div>
  </form>

  <div class="tone-subheader">
    <p class="subheader">Tone of post</p>
  </div>
  <form [formGroup]="workflowForm">
    <div>
      <mat-form-field appearance="fill">
        <mat-label>Select Tone</mat-label>
        <mat-select formControlName="postTone">
          <mat-option value="creative">Creative</mat-option>
          <mat-option value="inspirational">Inspirational</mat-option>
          <mat-option value="professional">Professional</mat-option>
          <mat-option value="friendly">Friendly</mat-option>
          <mat-option value="interactive">Interactive</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</div>

<div class="btn-container">
  <button class="btn btn-primary" type="submit" (click)="askGenAi()">
    Generate post
  </button>
</div>
